import React from 'react'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'
import { isMobile } from 'react-device-detect'

const CustomTooltip = ({
  children,
  tootipId,
  className = '',
  tooltipText,
  placement = 'bottom',
}) => {
  return (
    <OverlayTrigger
      placement={isMobile ? 'bottom' : placement} // Force bottom on mobile
      overlay={
        <Tooltip id={tootipId} className="custom-tooltip">
          <div
            className={className}
            style={{ maxWidth: "200px" }} 
          >
            {tooltipText}
          </div>
        </Tooltip>
      }
    >
      {children}
    </OverlayTrigger>
  )
}

export default CustomTooltip;
